module.exports = __webpack_public_path__ + "img/logo.a5f64306.png";